import { useEffect, useState } from 'react'
import { Popover, Select } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { getMemberKey, getNodeLabel } from 'Services/WeaverUtils'

NewTabButton = ({ activeTypes, onAdd }) ->

  [search, setSearch] = useState(undefined)
  [visible, setVisible] = useState(false)
  [classNameOptions, setClassNameOptions] = useState([])

  useEffect( ->
    ( ->
      types = await new Weaver.Query()
        .hasRelationIn(getMemberKey())
        .find()
      setClassNameOptions(
        types.map((type) ->
          { value: type.id(), label: getNodeLabel(type) }
        )
      )
    )()
    undefined
  , [])

  content = (
    <Select
      onSearch={(val) -> setSearch(val) if val isnt ''}
      showSearch
      options={_.uniqBy(classNameOptions.concat([{ value: search, label: search }]), 'value')}
      style={{ width: 300 }}
      placeholder="Open nodes of this type in a new tab"
      value={activeTypes}
      onSelect={(args...) ->
        onAdd(args...)
        setVisible(false)
      }
    />
  )

  handleVisibleChange = (visible) ->
    setVisible(visible)

  <Popover
    content={content}
    trigger="click"
    visible={visible}
    onVisibleChange={handleVisibleChange}
    destroyTooltipOnHide
  >
    <PlusOutlined />
  </Popover>

export default NewTabButton